import React from "react";

const Chip = (props: any) => {
    return (
        <>
        {props.label && <label>{props.label}</label>}
            {props?.item?.length > 0 ?
                <div className="chipset" >
                    {props?.item?.length > 0 && props?.item?.map((value, index) => {
                        return (
                            <span className="chiptag" key={index}>
                                {value.name || value}
                            </span>
                        )
                    })}
                </div> : ""}

        </>
    );
};

export default Chip;